import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/Service/Common.service';

@Component({
  selector: 'app-ccn-print',
  templateUrl: './ccn-print.component.html',
  styleUrls: ['./ccn-print.component.css']
})
export class CcnPrintComponent implements OnInit {
  public reportServer!: string;
  public reportUrl!: string;
  public showParameters!: string;
  public parameters: any;
  public language!: string;
  public height!: number;
  public width!: number;
  public toolbar!: string;

  constructor(
    public dialogRef: MatDialogRef<CcnPrintComponent>,
    @Inject(MAT_DIALOG_DATA) public ccn: any,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.EmbedSSRSReport();
  }

  public EmbedSSRSReport() {
    this.reportServer = environment.reportHost + "EIP40Reports/EIP4EDMS/EDMS/EDMSCCNPrint";
    this.reportUrl = environment.reportHost + "EIP40Reports/EIP4EDMS/EDMS/EDMSCCNPrint";
    this.showParameters = "false"; 
    this.parameters = {
      "CCN_Id": this.ccn.ccnId,
      "CCN_Rev_No": this.ccn.ccnRevNo,
      "Disc_Code": this.ccn.discCode,
      "Project_Id": this.commonService.getProjectId()
    };
    this.language = "en-us";
    this.width = 1000;
    this.height = 620;
    this.toolbar = "true";
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
